import Vue from "vue";
import "./plugins/vuetify";
import "./plugins/vuefire";
import { auth } from "./plugins/firebase";
import "./plugins/rules";
import App from "./App.vue";
import router from "./router";
import IconPicker from "./components/IconPicker";
// import store from "./store";
// import "./registerServiceWorker";
Vue.component("IconPicker", IconPicker);
Vue.config.productionTip = false;

const unsubscribe = auth.onAuthStateChanged(() => {
  unsubscribe();
  new Vue({
    router,
    // store,
    render: h => h(App)
  }).$mount("#app");
});
